import Grid from '@material-ui/core/Grid';
import { modalContentColor, modalMainContentColor, modalSubContentColor, modalStressTextColor } from "../lib/Color";
import { Paper } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { ArtSkillDataType, ModeType } from "./hooks/AssetSettingModalType";
import { PositionType, PlayerType } from "../Type/TeamType";
import { AssetToolTip } from './AssetToolTip';

type Props = {
    player: PlayerType;
    isAuto: boolean;
    selectedPosition: PositionType;
    artSkillData: ArtSkillDataType[];
    updateTeamMemberArtSkillData: (artSkillData: ArtSkillDataType) => void,
    onSelectStatePosition: (position: PositionType) => void,
    defenceTeamSelect: () => void
    close: () => void
}

const ArtSkillSettingContent = ({
    player,
    isAuto,
    selectedPosition,
    artSkillData,
    updateTeamMemberArtSkillData,
    onSelectStatePosition,
    defenceTeamSelect,
    close
}: Props) => {
    const nextTeamPosition = (): PositionType => {
        switch (selectedPosition) {
            case "FRONT":
                return "MIDDLE";
            case "MIDDLE":
                return "BACK";
            case "BACK":
                return "FRONT"
        }
    }
    const updateMember = (artSkill: ArtSkillDataType) => {
        updateTeamMemberArtSkillData(artSkill)
        // TODO リファクタリング
        if (isAuto) {
            if (selectedPosition === "BACK") {
                player === "Attack" ? defenceTeamSelect() : close()
            } else {
                onSelectStatePosition(nextTeamPosition());
            }
        } else {
            if (selectedPosition !== "BACK") {
                onSelectStatePosition(nextTeamPosition());
            }
        }
    }

    return (
        <>
            <Grid container style={{ backgroundColor: modalContentColor, height: '80vh' }} >
                <Grid item style={{ height: '90%', width: "100%", marginTop: "60px", marginRight: "10px", marginLeft: "10px", overflow: "auto", backgroundColor: modalMainContentColor, borderColor: "white" }}>
                    <Grid container >
                        {
                            artSkillData.length && artSkillData.map((artSkill) => {
                                return <Grid item xs={3} key={artSkill.id} onClick={() => updateMember(artSkill)}>
                                    <AssetToolTip
                                        title={
                                            <>
                                                {artSkill.effect}
                                            </>
                                        }
                                    >
                                        <Paper elevation={4} style={{
                                            height: '64px', width: "90%", margin: "10px", textAlign: "center", display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: modalSubContentColor
                                        }}>
                                            <Typography variant="h6" style={{ color: modalStressTextColor }}>
                                                {artSkill.name}
                                            </Typography>
                                        </Paper>
                                    </AssetToolTip>
                                </Grid>
                            })
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ArtSkillSettingContent;